import common from './front-common';
import pagesHome from './pages/home';
import pagesAbout from './pages/about';
import pagesChef from './pages/chef';
import pagesChefEvent from './pages/chefevent';
import pages404 from './pages/404';
import pagesGuide from './pages/guide';
import pagesDownload from './pages/download';
import pagesMessage from './pages/message';
import pagesPartner from './pages/partner';
import pagesPress from './pages/press';
import pagesRestaurantSearch from './pages/restaurant-search';
import pagesRestaurant from './pages/restaurant';
import pagesSpecial from './pages/special';
import pagesMaintenance from './pages/maintenance';
import pagesEntryCondition from './pages/entry/condition';
import pagesEntryBranch from './pages/entry/branch';
import pagesEntryBasic from './pages/entry/input-basic';
import pagesEntryDetail from './pages/entry/input-detail';
import pagesEntryParticipantInput from './pages/entry/participant/input';
import pagesEntryParticipantConfirm from './pages/entry/participant/confirm';
import pagesEntryEditEntry from './pages/entry/edit/input-entry';
import pagesEntryEditParticipant from './pages/entry/edit/input-participant';
import '@/css/front.scss';

common();
pages404();
pagesHome();
pagesAbout();
pagesChef();
pagesChefEvent();
pagesGuide();
pagesDownload();
pagesMessage();
pagesPartner();
pagesPress();
pagesRestaurantSearch();
pagesRestaurant();
pagesSpecial();
pagesMaintenance();
pagesEntryCondition();
pagesEntryBranch();
pagesEntryBasic();
pagesEntryDetail();
pagesEntryParticipantInput();
pagesEntryParticipantConfirm();
pagesEntryEditEntry();
pagesEntryEditParticipant();
